/*
 * @Author: lsqbeyond
 * @Date: 2025-09-02 21:25:53
 * @LastEditTime: 2025-10-06 13:23:05
 * @FilePath: \tracenew\src\main.js
 * @Description: 
 * Copyright (c) 2025 by STARGIS, All Rights Reserved. 
 */
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import i18n from './i18n'
import clickOutside from './directives/clickOutside'

// 引入Element UI
Vue.use(ElementUI)

// 注册全局指令
Vue.directive('click-outside', clickOutside)

// 创建Vue实例
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
